export default "__VITE_ASSET__$HnNcEXw__"